import { css } from 'lit';
/* eslint-disable import/prefer-default-export */
import { Store, Unsubscribe } from 'redux';

interface CustomElement {
	connectedCallback?(): void;
	disconnectedCallback?(): void;
	readonly isConnected: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Constructor<T> = new (...args: any[]) => T;

export const connect =
	<S>(store: Store<S>) =>
	<T extends Constructor<CustomElement>>(baseElement: T) =>
		class extends baseElement {
			_storeUnsubscribe!: Unsubscribe | null;

			override connectedCallback() {
				if (super.connectedCallback) {
					super.connectedCallback();
				}

				// Only subscribe if not already subscribed
				if (!this._storeUnsubscribe) {
					this._storeUnsubscribe = store.subscribe(() => {
						// Guard against calls after disconnect
						if (this.isConnected) {
							this.stateChanged(store.getState());
						}
					});
					this.stateChanged(store.getState());
				}
			}

			override disconnectedCallback() {
				// Unsubscribe first, before calling super
				if (this._storeUnsubscribe) {
					this._storeUnsubscribe();
					this._storeUnsubscribe = null; // Critical: null out the reference
				}

				if (super.disconnectedCallback) {
					super.disconnectedCallback();
				}
			}

			stateChanged(_state: S) {}
		};
